// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

export { pauseLowPriorityEvents } from './event-delay-controller.ts';
export { resumeLowPriorityEvents } from './event-delay-controller.ts';
